import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withGlobalError } from '@/react-tools/react-query';

import { Recommendation } from './types';
import { queryKeys } from './queryKeys';

async function getRecommendations(): Promise<Recommendation[]> {
  try {
    const { data } = await axios.get<Recommendation[]>('/recommendations');
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve recommendations');
  }
}

export function useRecommendations<TSelect = Recommendation[]>({
  enabled = true,
  select,
}: {
  enabled?: boolean;
  select?: (data: Recommendation[]) => TSelect;
} = {}) {
  return useQuery({
    queryKey: queryKeys.base(),
    queryFn: getRecommendations,
    refetchInterval: 5 * 60 * 1000,
    enabled,
    select,
    ...withGlobalError('Unable to load recommendations'),
  });
}
